import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import Card from "../../../components/Card";
import { Link, useLocation } from "react-router-dom";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import axios from "axios";
import {
  FaEye,
  FaPlus,
  FaClipboardList,
  FaRegCommentDots,
} from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import Loading from "../../../components/common/Loading";

function SendQuery() {
  const location = useLocation();
  const course =
    JSON.parse(localStorage.getItem("course")) ?? location.state?.course;
  localStorage.setItem("course", JSON.stringify(course));
  const courseData = course?.student;
  console.log(course);
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [queries, setQueries] = useState([]);
  const [selectedProblem, setSelectedProblem] = useState("");
  const [sendQueryData, setSendQueryData] = useState({
    school_code: course?.school_code,
    problem_type: "",
    description: "",
    student_name: courseData?.student_name,
    adm_no: courseData?.adm_no,
    level: courseData?.level,
    acadmic_year: courseData?.academic_year,
    combination_code: courseData?.combination_code,
    section: courseData?.section,
  });

  const query_problem_types = [
    "Attendance Issues",
    "Assignment Submission Problems",
    "Course Content Not Loading",
    "Login and Authentication Issues",
    "Notification and Alert Failures",
    "Discussion Forum or Chat Issues",
    "Feedback and Result Delays",
    "Mobile App Functionality Problems",
  ];

  const [loading, setLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  // const [pageLoading, setPageLoading] = useState(true);

  // useEffect(() => {
  //   setTimeout(() => setPageLoading(false), 2000);
  // }, [])

  const getQuiries = async () => {
    try {
      setLoading(true);
      const response = await axios.post(webServiceUrl.getQueries, {
        school_code: course?.school_code,
        student_name: courseData?.student_name,
        adm_no: courseData?.adm_no,
      });

      console.log(response?.data, "from getQueries");
      setQueries(response?.data?.data ?? "");
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  const sendQueryForm = async () => {
    try {
      // Optional: Validate form fields before submission
      if (!sendQueryData.problem_type || !sendQueryData.description) {
        toast.warn("Please fill in all required fields.");
        return;
      }
      setLoading(true);
      // setIsUpdating(true);
      // Send request
      const response = await axios.post(webServiceUrl.sendQuery, sendQueryData);
      console.log(response?.data, "from sendQuery");

      // Handle success
      if (response?.data?.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Optional: Reset form or close modal
        setSendQueryData((prev) => ({
          ...prev,
          problem_type: "",
          description: "",
        }));
        setShow2(false); // Close modal
        getQuiries(); // Refresh queries list
      } else {
        toast.error(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Send Query Error:", error);
      if (error.response) {
        // Server responded with a status other than 2xx
        toast.error(error.response.data?.message || "Server error occurred.");
      } else if (error.request) {
        // Request was made but no response received
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setTimeout(() => setLoading(false), 1500);
    }
  };

  useEffect(() => {
    getQuiries();
  }, []);

  // if (pageLoading) {
  //   return (
  //     <>
  // <div
  //   className="d-flex justify-content-center "
  //   style={{ height: "85vh", paddingTop: "15vh" }}
  // >
  //   <Oval
  //     height="50"
  //     width="50"
  //     color="#4fa94d"
  //     secondaryColor="#4fa94d"
  //   />
  // </div>
  //     </>
  //   );
  // }

  // ---- UI-only helper: maps a status string to a Bootstrap badge style ----
  const getStatusBadgeClass = (status) => {
    const normalized = (status || "").toLowerCase();
    if (normalized.includes("resolved") || normalized.includes("closed")) {
      return "badge rounded-pill text-bg-success px-3 py-2";
    }
    if (normalized.includes("progress")) {
      return "badge rounded-pill text-bg-info px-3 py-2";
    }
    if (normalized.includes("pending") || normalized.includes("open")) {
      return "badge rounded-pill text-bg-warning px-3 py-2";
    }
    return "badge rounded-pill text-bg-secondary px-3 py-2";
  };

  return (
    <div id="content-page" className="content-inner">
      <ToastContainer />
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg="12">
            <Card
              className="shadow border-0 rounded-4 overflow-hidden px-2"
              style={{ background: "#ffffff" }}
            >
              <Card.Header
                className="mt-1 mt-md-4 py-3 border-0"
                style={{ background: "transparent" }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
                  {/* LEFT SIDE */}
                  <div className="header-title d-flex align-items-center gap-2">
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                      style={{
                        width: 42,
                        height: 42,
                        background: "#16a34a",
                        color: "#fff",
                      }}
                    >
                      <FaClipboardList size={18} />
                    </span>
                    <div>
                      <h4
                        className="card-title mb-0 fw-bold"
                        style={{ fontSize: "clamp(1.1rem, 4vw, 1.5rem)" }}
                      >
                        Queries
                      </h4>
                      <small className="text-muted d-block">
                        Track and raise support requests
                      </small>
                    </div>
                  </div>

                  {/* RIGHT SIDE BUTTON */}
                  <button
                    type="button"
                    className="btn d-flex align-items-center justify-content-center gap-2 px-4 py-2 rounded-pill fw-semibold border-0 flex-shrink-0"
                    style={{
                      background: "#16a34a",
                      color: "#fff",
                      boxShadow: "0 4px 14px rgba(22, 163, 74, 0.35)",
                    }}
                    onClick={() => setShow2(true)}
                    disabled={loading}
                  >
                    <FaPlus size={12} />
                    <span className="d-none d-sm-inline">Send New Query</span>
                    <span className="d-inline d-sm-none">New Query</span>
                  </button>
                </div>
              </Card.Header>

              <Modal
                scrollable={true}
                show={show2}
                onHide={handleClose2}
                centered
                fullscreen="sm-down"
                contentClassName="rounded-4 border-0 overflow-hidden"
              >
                <Modal.Header
                  closeButton
                  className="border-0 pb-0"
                  style={{
                    background: "#16a34a",
                  }}
                >
                  <Modal.Title className="w-100">
                    <div className="d-flex align-items-center gap-2 text-white pb-3">
                      <FaRegCommentDots size={20} />
                      <h5 className="mb-0 fw-bold">Send a New Query</h5>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-4 px-3 px-md-4">
                  <Form>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="form-group mb-3">
                          <Form.Label className="fw-semibold text-secondary small text-uppercase">
                            Query Type
                          </Form.Label>
                          <Form.Control
                            as="select"
                            required
                            className="rounded-3 py-2"
                            style={{ borderColor: "#bbf7d0" }}
                            value={sendQueryData.problem_type}
                            onChange={(e) =>
                              setSendQueryData({
                                ...sendQueryData,
                                problem_type: e.target.value,
                              })
                            }
                          >
                            <option value="" disabled>
                              Select a Query
                            </option>
                            {query_problem_types.map((problem, idx) => (
                              <option key={idx} value={problem}>
                                {problem}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group className="form-group mb-2">
                          <Form.Label className="fw-semibold text-secondary small text-uppercase">
                            Description
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            required
                            placeholder="Describe your issue in detail..."
                            className="rounded-3"
                            style={{ borderColor: "#bbf7d0" }}
                            value={sendQueryData.description}
                            onChange={(e) =>
                              setSendQueryData({
                                ...sendQueryData,
                                description: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Modal.Body>

                <Modal.Footer className="border-0 px-3 px-md-4 pb-4 pt-0 flex-column flex-sm-row gap-2">
                  <Button
                    variant="light"
                    onClick={handleClose2}
                    className="px-4 rounded-pill fw-semibold w-100 w-sm-auto order-2 order-sm-1"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={sendQueryForm}
                    className="px-5 rounded-pill fw-semibold border-0 w-100 w-sm-auto order-1 order-sm-2"
                    style={{
                      background: "#16a34a",
                    }}
                    disabled={loading}
                  >
                    Submit
                  </Button>
                </Modal.Footer>
              </Modal>

              <Card.Body className="pt-0 px-2 px-md-3">
                {/* ---------- Desktop / tablet: table layout (md and up) ---------- */}
                <Row className="d-none d-md-flex">
                  <div className="table-responsive mt-2 rounded-4 overflow-hidden border">
                    <Table
                      hover
                      responsive
                      className="mb-0 align-middle"
                      style={{ fontSize: "0.92rem" }}
                    >
                      <thead>
                        <tr
                          style={{
                            background: "#f0fdf4",
                            borderBottom: "2px solid #16a34a",
                          }}
                        >
                          <th className="py-3 text-secondary text-uppercase small fw-bold">
                            Sr.No
                          </th>
                          <th className="py-3 text-secondary text-uppercase small fw-bold">
                            Problem Type
                          </th>
                          <th className="py-3 text-secondary text-uppercase small fw-bold">
                            Description
                          </th>
                          <th className="py-3 text-secondary text-uppercase small fw-bold">
                            Status
                          </th>
                          <th className="py-3 text-secondary text-uppercase small fw-bold">
                            Last Response On
                          </th>
                          <th className="py-3 text-secondary text-uppercase small fw-bold text-center">
                            View Thread
                          </th>
                        </tr>
                      </thead>

                      {loading ? (
                        <tbody>
                          <tr>
                            <td colSpan="6" className="border-0">
                              <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                <Oval
                                  height="45"
                                  width="45"
                                  color="#16a34a"
                                  secondaryColor="#dcfce7"
                                />
                                <span className="text-muted small mt-2">
                                  Loading queries...
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {queries.length > 0 ? (
                            queries.map((file, index) => (
                              <tr key={index}>
                                <td className="text-muted">{index + 1}</td>
                                <td className="fw-semibold">
                                  {file.problem_type}
                                </td>
                                <td
                                  className="text-truncate"
                                  style={{ maxWidth: 260 }}
                                  title={file.description}
                                >
                                  {file.description}
                                </td>
                                <td>
                                  <span
                                    className={getStatusBadgeClass(file.status)}
                                  >
                                    {file.status}
                                  </span>
                                </td>
                                <td className="text-muted">
                                  {(() => {
                                    const d = new Date(file.last_response_on);
                                    const day = d
                                      .getDate()
                                      .toString()
                                      .padStart(2, "0");
                                    const month = d.toLocaleString("default", {
                                      month: "long",
                                    });
                                    const year = d.getFullYear();
                                    return `${day}-${month}-${year}`;
                                  })()}
                                </td>
                                <td className="text-center">
                                  <Link
                                    to={{
                                      pathname: `/dashboard/program/view-threads/${file.enquiry_id}`,
                                    }}
                                    state={{
                                      file,
                                      school_code: course?.school_code,
                                    }}
                                    className="d-inline-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                                    style={{
                                      width: 34,
                                      height: 34,
                                      background: "#f0fdf4",
                                      border: "1px solid #bbf7d0",
                                      color: "#16a34a",
                                    }}
                                  >
                                    <FaEye size={14} />
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="border-0">
                                <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                                  <FaClipboardList
                                    size={34}
                                    className="mb-2 opacity-50"
                                  />
                                  <span>No queries found</span>
                                  <small>
                                    Click "Send New Query" to raise one
                                  </small>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </Table>
                  </div>
                </Row>

                {/* ---------- Mobile: stacked card layout (below md) ---------- */}
                <div className="d-md-none mt-2">
                  {loading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center py-5">
                      <Oval
                        height="42"
                        width="42"
                        color="#16a34a"
                        secondaryColor="#dcfce7"
                      />
                      <span className="text-muted small mt-2">
                        Loading queries...
                      </span>
                    </div>
                  ) : queries.length > 0 ? (
                    <div className="d-flex flex-column gap-3">
                      {queries.map((file, index) => (
                        <div
                          key={index}
                          className="rounded-4 border p-3"
                          style={{ background: "#fafffb" }}
                        >
                          <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                            <h6
                              className="fw-bold mb-0"
                              style={{ maxWidth: "75%" }}
                            >
                              {file.problem_type}
                            </h6>
                            <span className={getStatusBadgeClass(file.status)}>
                              {file.status}
                            </span>
                          </div>

                          <p
                            className="text-muted small mb-2"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                            title={file.description}
                          >
                            {file.description}
                          </p>

                          <div className="d-flex justify-content-between align-items-center">
                            <div className="text-muted small">
                              {(() => {
                                const d = new Date(file.last_response_on);
                                const day = d
                                  .getDate()
                                  .toString()
                                  .padStart(2, "0");
                                const month = d.toLocaleString("default", {
                                  month: "long",
                                });
                                const year = d.getFullYear();
                                return `${day}-${month}-${year}`;
                              })()}
                            </div>

                            <Link
                              to={{
                                pathname: `/dashboard/program/view-threads/${file.enquiry_id}`,
                              }}
                              state={{
                                file,
                                school_code: course?.school_code,
                              }}
                              className="d-inline-flex align-items-center gap-2 rounded-pill text-decoration-none px-3 py-1 fw-semibold"
                              style={{
                                background: "#f0fdf4",
                                border: "1px solid #bbf7d0",
                                color: "#16a34a",
                              }}
                            >
                              <FaEye size={13} />
                              View
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-muted rounded-4 border">
                      <FaClipboardList size={30} className="mb-2 opacity-50" />
                      <span>No queries found</span>
                      <small className="text-center px-3">
                        Click "Send New Query" to raise one
                      </small>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SendQuery;
